<template>
  <div class="mx-auto w-full max-w-screen-sm px-4.5 xs:px-5.5">
    <slot />
  </div>
</template>
